<template>
  <div class="edit-users-groups-right rule-set conmon-top">
    <el-row class="users-groups-content">
      <el-col :span="24" class="add-product-info-search-title" style="padding: 20px 0 0 20px;text-align: left">
        <span class="product-info-span">当前角色: <span style="color:#4882ff">{{form.title}}</span></span>
      </el-col>
    </el-row>
    <el-form ref="form" :model="form" :rules="rules" label-width="40px" class="edit-users-groups-form form-submit-page" style="width: 97%">
      <!-- <el-form-item label="用户组名称" prop="title">
        <el-input v-model.trim="form.title" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="父级用户组" prop="pid">
        <el-select v-model="form.pid" placeholder="父级用户组" class="w-200">
          <el-option v-for="item in options" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="备注"
          v-model="form.remark"
          class="w-200">
        </el-input>
      </el-form-item> -->
      <el-form-item>
        <div class=" bor-ra-5 bg-wh">
          <div :key="index" v-for="(item, index) in nodes" style="text-align: left;">
           <!--  <div class="bor-b-ccc bg-gra p-l-10 p-r-10">
              <el-checkbox v-model="item.check" @change="selectProjectRule(item)">{{item.else}}</el-checkbox>
            </div> -->
            <div :key="i" v-for="(childItem, i) in item.child" class="">
              <div class="p-l-20  bor-gray edit-users-groups-nodes" style="padding-left: 20px">
                <el-checkbox v-model="childItem.check" @change="selectModuleRule(childItem, item, childItem.child)">{{childItem.else}}</el-checkbox>
              </div>
              <div class="p-l-40 bg-gra bor-gray edit-users-groups-part" style="padding-left: 20px;background: #fff">
                <el-checkbox :key="j" v-for="(grandChildItem, j) in childItem.child" v-model="grandChildItem.check" @change="selectActionRule(grandChildItem, childItem, item)">{{grandChildItem.else}}</el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="edit-users-groups-commit-content" style="margin: 0 auto 10px">
        <el-button class="second-page-btn" type="primary" @click="edit('form')" :loading="isLoading" style="margin: 0 auto;display: block;float: none">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getWithInList, getRoleDetail, editRole } from '@/api/customer.js'
export default {
  data() {
    return {
      isLoading: false,
      type: 'tree',
      form: {
        id: null,
        title: '',
        pid: '',
        remark: '',
        rules: [],
        status: null
      },
      options: [{ pid: '0', title: '无' }],
      nodes: [],
      selectedNodes: [],
      rules: {
        title: [
          { required: true, message: '请输入用户组名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 保存编辑
    edit(form) {
      let id = this.$route.query.id
      this.form.rules = this.selectedNodes.toString()
      this.$refs[form].validate((valid) => {
        if (valid) {
          editRole(this.form.title, this.form.remark, this.form.rules, id).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', '编辑成功')
              router.push('/home/administrative/position-list')
            }
          })
          this.isLoading = !this.isLoading
        }
      })
    },
    // 选择大的checkbox
    selectModuleRule(item, faItem, children) {
      if (!faItem.check) {
        faItem.check = true
        this.selectedNodes.push(faItem.id)
      }
      if (item.check) {
        this.selectedNodes.push(item.id)
        _(children).forEach((res) => {
          res.check = true
          this.selectedNodes.push(res.id)
        })
      } else {
        let index = _(this.selectedNodes).indexOf(item.id)
        this.selectedNodes.splice(index, 1)
        _(children).forEach((res1) => {
          let temp = _(this.selectedNodes).indexOf(res1.id)
          if (temp >= 0) {
            res1.check = false
            this.selectedNodes.splice(temp, 1)
          }
        })
      }
    },
    // 选择小的checkbox
    selectActionRule(item, faItem, grandFaItem) {
      if (!faItem.check) {
        faItem.check = true
        this.selectedNodes.push(faItem.id)
      }
      if (!grandFaItem.check) {
        grandFaItem.check = true
        this.selectedNodes.push(grandFaItem.id)
      }
      this.selectRule(item)
    },
    selectRule(item) {
      if (item.check) {
        this.selectedNodes.push(item.id)
      } else {
        const index = _(this.selectedNodes).indexOf(item.id)
        this.selectedNodes.splice(index, 1)
      }
    },
    load() {
      let id = this.$route.query.id
      // 获取权限集合
      let getRule = getWithInList(this.type)
      // 获取角色详情
      let getRoleDetails = getRoleDetail(id)
      // promise
      Promise.all([getRule, getRoleDetails]).then(res => {
        // 处理属性
        if (res[0].data.code === 0) {
          this.nodes = res[0].data.data.list
        }
        // 处理群组
        if (res[1].data.code === 0) {
          this.form.title = res[1].data.data.title
          this.form.remark = res[1].data.data.remark
          this.form.pid = res[1].data.data.pid ? res[1].data.data.pid.toString() : ''
          this.form.status = res[1].data.data.status
          if (res[1].data.data.rules === null) {
            return
          }
          let array = res[1].data.data.rules.split(',')
          _(array).forEach((ret) => {
            this.selectedNodes.push(parseInt(ret))
          })
          _(this.nodes).forEach((ret) => {
            if (_.includes(this.selectedNodes, ret.id)) {
              ret.check = true
            }
            _(ret.child).forEach((ret1) => {
              if (_(this.selectedNodes).includes(ret1.id)) {
                ret1.check = true
              }
              _(ret1.child).forEach((ret2) => {
                if (_(this.selectedNodes).includes(ret2.id)) {
                  ret2.check = true
                }
              })
            })
          })
        }
      })
    }
  },
  created() {
    this.load()
  }
}
</script>
<style type="text/css" scoped>
.edit-users-groups-right {
  float: left;
  background-color: #fff;
  border: 1px solid #dedede;
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-top: 20px!important;
}
.users-groups-content {
  float: left;
  width: 100%;
  border-radius: 0px;
}
.edit-users-groups-form {
  float: left;
  /*margin-top: 20px;*/
}
.edit-users-groups-nodes {
  margin-top: 20px;
  background: #ebeff4;
  /*border-top: 1px solid #dedede;*/
}
.edit-users-groups-part {
  border-top-width: 0px !important;
}
.edit-users-groups-commit-content {
  margin-left: 37%;
  margin-top: 40px;
}
.edit-users-groups-back {
  background-color: #4882ff;
  color: #fff;
  float: right;
  margin-right: 20px;
  padding: 5px 20px 5px 20px;
  margin-top: 10px;
}
.el-checkbox{
  margin-right: 30px;
  margin-left: 0 !important;
}
.el-checkbox+.el-checkbox{
  margin-left: 0;
}
</style>
